import React from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "./ui";

const SOCIAL_LINKS = [
  { href: "https://www.linkedin.com/company/7603237/", label: "LinkedIn", path: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.048c.476-.9 1.637-1.852 3.37-1.852 3.601 0 4.267 2.37 4.267 5.455v6.288zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" },
  { href: "https://www.instagram.com/ekkbaz/", label: "Instagram", path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" },
  { href: "https://www.youtube.com/c/EkkBaz", label: "YouTube", path: "M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" },
  { href: "https://wa.me/+6592344538", label: "WhatsApp", path: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.687 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" },
];

const COLS = [
  { title: "Agents", links: [
    { label: "AR collections", to: "/agents#ar-collections" },
    { label: "Supplier onboarding", to: "/agents#supplier-onboarding" },
    { label: "WhatsApp commerce", to: "/agents#whatsapp" },
    { label: "CX concierge", to: "/agents#cx-concierge" },
    { label: "Demand forecast", to: "/agents#demand-forecast" },
    { label: "See all agents →", to: "/agents" },
  ]},
  { title: "Industries", links: [
    { label: "Consumer goods", to: "/industries#consumer-goods" },
    { label: "Electronics", to: "/industries#electronics" },
    { label: "Healthcare", to: "/industries#healthcare" },
    { label: "Hospitality", to: "/industries#hospitality" },
    { label: "Film & media", to: "/industries#film" },
    { label: "Manufacturing", to: "/industries#manufacturing" },
  ]},
  { title: "Company", links: [
    { label: "About", to: "/company#about" },
    { label: "Contact", to: "/company#contact" },
    { label: "Pricing", to: "/#pricing", anchor: true },
    { label: "Security", to: "/#security", anchor: true },
  ]},
];

const FooterCol = ({ title, links }) => (
  <div>
    <div className="font-mono text-[10.5px] uppercase tracking-[0.22em] text-white/40">{title}</div>
    <ul className="mt-4 space-y-2.5">
      {links.map(l => (
        <li key={l.label}>
          {l.anchor
            ? <a href={l.to.replace("/", "")} className="text-[13.5px] text-white/70 hover:text-white">{l.label}</a>
            : <Link to={l.to} className="text-[13.5px] text-white/70 hover:text-white">{l.label}</Link>
          }
        </li>
      ))}
    </ul>
  </div>
);

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.06] bg-[#040818] pt-16 pb-10">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[1.4fr,1fr,1fr,1fr]">
          <div className="max-w-sm">
            <Wordmark />
            <p className="mt-4 text-[13.5px] leading-relaxed text-white/55">
              EkkBaz AI builds custom, self-learning, autonomous AI agents that take over the operational work that&rsquo;s quietly killing your margin.
            </p>
            <div className="mt-5 flex items-center gap-3">
              {SOCIAL_LINKS.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="grid h-9 w-9 place-items-center rounded-full border border-white/10 text-white/70 hover:bg-white/[0.06] hover:text-white">
                  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d={s.path} /></svg>
                </a>
              ))}
            </div>
          </div>
          {COLS.map(c => <FooterCol key={c.title} {...c} />)}
        </div>
        <div className="mt-14 flex flex-col items-start gap-4 border-t border-white/[0.06] pt-6 text-[12px] text-white/45 lg:flex-row lg:items-center lg:justify-between">
          <div>© {new Date().getFullYear()} EkkBaz AI Corp · All rights reserved.</div>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" className="hover:text-white">Privacy</Link>
            <Link to="/terms-conditions" className="hover:text-white">Terms</Link>
            <Link to="/refund-policy" className="hover:text-white">Refund policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
